import { render, staticRenderFns } from "./ClientMemberCard.vue?vue&type=template&id=7e2ac074"
import script from "./ClientMemberCard.vue?vue&type=script&lang=js"
export * from "./ClientMemberCard.vue?vue&type=script&lang=js"
import style0 from "./ClientMemberCard.vue?vue&type=style&index=0&id=7e2ac074&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports